import { ReactElement } from 'react';
import { sizes, Space } from 'settings/spaces';
import styled from 'styled-components';
import { ResponsiveProp, resolveResponsiveProp } from 'libs/utils/responsiveProps';
import { getNegativeCssValue } from 'libs/utils/getNegativeCssValue/getNegativeCssValue';
import { joinAndFilter } from 'libs/utils/joinAndFilter/joinAndFilter';
import keys from 'libs/utils/keys/keys';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ReactNodeArray extends Array<ReactNodeNoStrings> {}
export type ReactNodeNoStrings = ReactElement | ReactNodeArray | boolean | null | undefined;

const inverseSizes: Record<Space, string> = keys(sizes).reduce(
    (map, size) => ({
        ...map,
        [size]: getNegativeCssValue(map[size]),
    }),
    sizes
);

export interface InlineProps {
    space: ResponsiveProp<Space>;
}

export const Inline = styled.div<InlineProps>`
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;

    ${({ space }) => {
        const spaces = joinAndFilter(
            resolveResponsiveProp(space, 'margin-top', inverseSizes),
            resolveResponsiveProp(space, 'margin-left', inverseSizes)
        );
        return spaces;
    }}

    > * {
        ${({ space }) => {
            const spaces = joinAndFilter(
                resolveResponsiveProp(space, 'margin-top', sizes),
                resolveResponsiveProp(space, 'margin-left', sizes)
            );
            return spaces;
        }}
    }
`;
